var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.864,9.7376 L19.10912,9.7376 C17.72416,9.7376 17.456,10.39552 17.456,11.36128 L17.456,13.4912 L20.76672,13.4912 L20.33536,16.83392 L17.456,16.83392 L17.456,25.376 L14.00448,25.376 L14.00448,16.83392 L11.136,16.83392 L11.136,13.4912 L14.00448,13.4912 L14.00448,11.0304 C14.00448,8.17728 15.74656,6.624 18.29184,6.624 C19.51104,6.624 20.55872,6.71488 20.864,6.75584 L20.864,9.7376 Z M16,0 C7.16352,0 0,7.16352 0,16 C0,24.83648 7.16352,32 16,32 C24.83648,32 32,24.83648 32,16 C32,7.16352 24.83648,0 16,0 L16,0 Z",
    mask: "url(#group-3-b)"
  }))));
}

export default __webpack_public_path__ + "static/facebook-e1934c886a16f615b20492f4e75517b4.svg";
export { SvgFacebook as ReactComponent };